import logo1 from "../../assets/img/historicEvents/LogoOnlysPPV/ONO.png";

export const oneNightOnlyDetail = {
  "one-night-only": {
    id: "one-night-only",
    title: "One Night Only",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "one-night-only",
        items: [
          {
            id: "one-night-only-1",
            title: "One Night Only",
            description: "Birmingham, England 1997",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
